import { createFileRoute } from '@tanstack/react-router'
import DataExportSettings from '@/pages/settings/data-export'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/settings/data-export',
)({
  component: DataExportSettings,
})
